import Splide from '@splidejs/splide';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( document ).on( 'click', '.single-product-additional-details-read-more', function( e ) {
        $( e.target ).html( $( e.target ).hasClass( 'is-active' ) ? 'Read Less' : 'Read More' );
      } );

      if ( $( '.product-image-slider' ).length ) {
        const main = new Splide( '.product-image-slider', {
          type: 'fade',
          pagination: false,
          arrows: false,
          cover: true,
        } );

        const thumbnails = new Splide( '.product-thumbnail-slider', {
          rewind: true,
          arrows: true,
          direction: 'ttb',
          fixedHeight: '68px',
          fixedWidth: '68px',
          isNavigation: true,
          height: '308px',
          gap: '12px',
          perPage: 4,
          perMove: 1,
          pagination: false,
          breakpoints: {
            767: {
              direction: 'ltr',
              height: 'auto',
            },
          },
        } );

        main.sync( thumbnails );
        main.mount();
        thumbnails.mount();
      }

      if ( $( '.product-image-gallery' ).length ) {
        $( '.product-image-gallery img' ).each( ( key, image ) => {
          const dimensions = {
            width: image.naturalWidth,
            height: image.naturalHeight,
          };

          if ( image.closest( 'a' ) && image.closest( 'a' ).hasAttribute( 'data-pswp-width' ) ) {
            image.closest( 'a' ).dataset['pswpWidth'] = dimensions.width;
            image.closest( 'a' ).dataset['pswpHeight'] = dimensions.height;
          }
        } );

        const lightbox = new PhotoSwipeLightbox( {
          gallery: '.product-image-gallery',
          children: 'a',
          showHideAnimationType: 'zoom',
          pswpModule: PhotoSwipe,
        } );

        lightbox.init();
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'woocommerce', COMPONENT );
} )( app );
